// GetLiveContext — runs useGetLiveStatus once and shares it with the A2P trial
// banner and the Get-Live Companion so they don't double-fetch. Mounted in Layout.
import React, { createContext, useContext } from 'react';
import { useAuth } from '../../context/AuthContext';
import useGetLiveStatus from './useGetLiveStatus';

const GetLiveContext = createContext(null);

export function GetLiveProvider({ children }) {
  const { user } = useAuth();
  const status = useGetLiveStatus(user?.tenant_id);
  return <GetLiveContext.Provider value={status}>{children}</GetLiveContext.Provider>;
}

export function useGetLive() {
  return useContext(GetLiveContext);
}
